<template>
  <form>
    <v-card>
      <v-card-title>
        <span class="headline">
          {{ 
            mode === 'bulk' 
              ? $t('bulk_edit_client_trx_cfg') 
              : $t('client_configure_trx_cfg') 
          }}
        </span>
        <v-spacer></v-spacer>
        <v-btn
          icon
          @click="close"
        >
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-container v-if="mode === 'bulk'">
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="bulkEditFilter.clientList"
                  :label="$t('client')"
                  multiple
                  chips
                  deletable-chips
                  clearable
                  :items="allClientIdAndName"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-autocomplete
                  v-model="bulkEditFilter.commTypeList"
                  :label="$t('paytype')"
                  multiple
                  chips
                  deletable-chips
                  clearable
                  :items="PayTypes"
                  :item-text="x => x.code.toUpperCase()"
                  :item-value="x => x.code.toUpperCase()"
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-divider />
          </v-container>
          <v-card
            v-for="item in filterTrxCfg"
            :key="item.method"
            rounded="100"
            density="compact"
            class="mt-3"
          >
            <v-card-title>{{ item.comm_type }}</v-card-title>
            <v-card-text>
              <v-row
                v-for="(trx_cfg_cyc, idx) in item.trx_cfg_cyc"
                :key="
                  idx.toString() + '-' 
                    + trx_cfg_cyc.is_default + '-' 
                    + trx_cfg_cyc.currency_code
                "
              >
                <v-col cols="12" sm="1" align-self="center">
                  <v-btn 
                    v-if="!trx_cfg_cyc.is_default"
                    icon 
                    @click="removeTrxCfg(item._idx, idx)">
                    <v-icon>
                      mdi-delete-alert
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-combobox
                    v-if="!trx_cfg_cyc.is_default"
                    :label="$t('currency')"
                    :items="CurrencyList"
                    item-text="currency_code"
                    item-value="currency_code"
                    :return-object="false"
                    v-model="trx_cfg_cyc.currency_code"
                  >
                  </v-combobox>
                  <v-text-field
                    v-if="trx_cfg_cyc.is_default"
                    :label="$t('default')"
                    disabled
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    :label="$t('base_rate')"
                    v-model.number="trx_cfg_cyc.base_rate"
                    name="base_rate"
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    :label="$t('payment_rate')"
                    v-model.number="trx_cfg_cyc.rate"
                    name="payment_rate"
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    :label="$t('min_tx_amt')"
                    v-model.number="trx_cfg_cyc.min_amt"
                    name="base_rate"
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    :label="$t('max_tx_amt')"
                    v-model.number="trx_cfg_cyc.max_amt"
                    name="base_rate"
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="2" offset-sm="4">
                  <v-text-field
                    :label="$t('min_base_comm_amt')"
                    v-model.number="trx_cfg_cyc.min_base_comm_amt"
                    name="min_base_comm_amt"
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    :label="$t('min_comm_amt')"
                    v-model.number="trx_cfg_cyc.min_comm_amt"
                    name="min_comm_amt"
                    type="number"
                  />
                </v-col>
                <v-col cols="12" sm="2">
                  <v-select
                    :label="$t('cvr_mode')"
                    name="cvr_mode"
                    :items="supportedCvrMode"
                    v-model="trx_cfg_cyc.cvr_mode"
                  >
                  </v-select>
                </v-col>
                <v-col cols="12" sm="2">
                  <v-text-field
                    :label="$t('cvr_mode_max_amt')"
                    v-model.number="trx_cfg_cyc.cvr_mode_max_amt"
                    name="cvr_mode_max_amt"
                    type="number"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn 
                color="blue darken-1" 
                text 
                @click="addNewTrxCfg(item._idx)"
              >
                {{$t('add')}}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="close">{{$t('cancel')}}</v-btn>
        <v-btn color="blue darken-1" text @click="save" :loading="busy">{{$t('save')}}</v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>

<script>
  import axios from 'axios'
  import contactMixins from "../../mixins/contactMixins";
  import clientMixins from "./clientMixins";
  import currencyMixins from "../../mixins/currencyMixins";
  import y3Mixins from "../../mixins/y3Mixins";
  import DefClient from "../../constants/DefClient";

  export default {
    name: 'ClientTrxCfgForm',
    props: ['defaultItem', 'editedIndex', 'dialogVisible', 'mode', 'allClient'],
    mixins: [contactMixins, clientMixins, currencyMixins, y3Mixins],

    watch: {
      dialogVisible: {
        immediate: true,
        handler(visible) {
          if (visible) {
            this.fetchCurrency();

            // Reset bulk edit mode data

            this.bulkEditFilter = {
              clientList: [],
              commTypeList: [],
            };

            // Add a default profile if doesnt exist

            for (let i = 0; i < this.editedItem.trx_cfg.length; i++) {
              if (
                this.editedItem.trx_cfg[i].trx_cfg_cyc
                  .filter(x => x.is_default).length === 0
              ) {
                this.addTrxCfg(i, true);
              }
            }
          }
        }
      }
    },
    data: function() {
      return {
        supportedCvrMode: Object
          .entries(DefClient.CvrMode)
          .map(x => { return { value: x[1], text: x[0] }; }),
        bulkEditFilter: {
          clientList: [],
          commTypeList: [],
        },
      }
    },
    computed: {
      allClientIdAndName () {
        return this.allClient
          .filter(x => x.user_type === this.UserType.CLIENT)
          .map(x => ({ value: x.user_id, text: x.display_name}));
      },
      filterTrxCfg () {
        return this.editedItem.trx_cfg
          .map((x, idx) => ({...x, _idx: idx }))
          .filter(
            x => (
              this.mode !== 'bulk' || 
              this.bulkEditFilter.commTypeList.find(y => y === x.comm_type) 
                !== undefined
            )
          );
      }
    },
    methods: {
      addTrxCfg(commTypeIdx, addDflt) {
        if (commTypeIdx < 0 || commTypeIdx >= this.editedItem.trx_cfg.length) {
          return;
        }

        const trxCfgCyc = {
          is_default: addDflt,
          currency_code: null,
          min_amt: 0,
          max_amt: 0,
          base_rate: 0,
          rate: 0,
          min_base_comm_amt: 0,
          min_comm_amt: 0,
          cvr_mode: 0,
          cvr_mode_max_amt: null,
        };

        // Because editedItem is deep clone so here can freely modify, otherwise
        // cannot modify editedItem directly

        if (addDflt) {
          this.editedItem.trx_cfg[commTypeIdx].trx_cfg_cyc.unshift(trxCfgCyc);
        }
        else {
          this.editedItem.trx_cfg[commTypeIdx].trx_cfg_cyc.push(trxCfgCyc);
        }
      },
      addNewTrxCfg(idx) {
        this.addTrxCfg(idx, false);
      },
      removeTrxCfg(commTypeIdx, idx) {
        if (commTypeIdx < 0 || commTypeIdx >= this.editedItem.trx_cfg.length) {
          return;
        }

        if (
          idx < 0 || 
          idx >= this.editedItem.trx_cfg[commTypeIdx].trx_cfg_cyc.length
        ) {
          return;
        }

        if (this.editedItem.trx_cfg[commTypeIdx].trx_cfg_cyc[idx].is_default) {
          return;
        }

        this.editedItem.trx_cfg[commTypeIdx].trx_cfg_cyc.splice(idx, 1);
      },
      fetch() {
        this.$emit('fetch');
      },
      close () {
        this.$emit('close');
      },
      save () {
        this.editedItem.trx_cfg.forEach(
          x => {
            x.trx_cfg_cyc.forEach(
              y => {
                if (
                  typeof(y.cvr_mode_max_amt) === 'string' && 
                  y.cvr_mode_max_amt.trim() === ''
                ) {
                  y.cvr_mode_max_amt = null;
                }
              }
            );
          }
        );

        if (this.mode === 'bulk') {
          this.saveBulk();
        }
        else {
          this.saveSingle();
        }
      },
      saveSingle () {
        this.updateUser();
      },
      saveBulk () {
        const updClient = this.bulkEditFilter.clientList;
        const newTrxCfg = this.editedItem.trx_cfg
          .filter(
            x => this.bulkEditFilter.commTypeList.find(y => y === x.comm_type) 
              !== undefined
          );

        const _this = this;
        this.busy = true;

        axios
          .put(
            `/app/api/client/bulkupdtrxcfg`,
            {
              users: updClient,
              trx_cfg: newTrxCfg,
            }
          )
          .then(
            () => {
              _this.fetch();
              _this.close();
            }
          )
          .catch(
            error => {
              _this.$store.dispatch('snackbar/openSnackbar', {
                message: error.response.data.message,
                color: 'error',
              })
            }
          )
          .finally(
            () => {
              _this.busy = false;
            }
          );
      },
    }
  }
</script>
